export default "https://cdn.questicon.mathletics.com/assets/audio/scoreResults2Star-cbd85d1a7925f67774ebb85df22d3568.mp3";